import type { FunctionComponent, ReactNode } from 'react';

import {
  E_INVOICING,
  E_MODALITIES,
} from 'utils';

import IconModalities from 'assets/images/icon-briefcase-24px.svg';
import IconIvoice from 'assets/images/icon-invoice-24px.svg';
import IconProfile from 'assets/images/icon-profile-b-24px.svg';

import IconStats from 'assets/images/icon-stats-24px.svg';

import Item from './Item';

import './style.scss';

const DisabledItem: FunctionComponent<{
  children: ReactNode;
}> = ({ children }) => (
  <span styleName="disabled-item">
    {children}
  </span>
);
type PropsT = {
  // An alternative here might be to wrap it all into an additional <Routes>
  baseUrl: string;
  isLive?: boolean;
  onToggleLive?: () => void;
  publicUrl?: string;
};

export const ProfileMenu: FunctionComponent<PropsT> = ({
  baseUrl,
  isLive,
  onToggleLive,
  publicUrl,
}) => (
  <div styleName="container">
    <div styleName="tabs">
      <Item to={baseUrl}>
        <IconProfile /> <span styleName="label">My Page</span>
      </Item>
      <Item to={`${baseUrl}${E_MODALITIES}`}>
        <IconModalities /> <span styleName="label">Account</span>
      </Item>
      <Item to={`${baseUrl}${E_INVOICING}`}>
        <IconIvoice /> <span styleName="label">Invoicing</span>
      </Item>
      <DisabledItem>
        <IconStats /> <span styleName="label">Performance</span>
      </DisabledItem>
    </div>
    {!!(onToggleLive ?? publicUrl) && (
      <div styleName="right">
        {!!onToggleLive && (
          <button
            onClick={onToggleLive}
            styleName={isLive ? 'toggle-btn live' : 'toggle-btn not-live'}
            type="button"
          >
            {isLive ? 'Your page is live' : 'Your page is not live yet'}
          </button>
        )}
        {!!publicUrl && (
          <a
            href={publicUrl}
            rel="noopener noreferrer"
            styleName="view-page"
            target="_blank"
          >
            View My Page
            <svg
              fill="none"
              height="14"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              width="14"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
              />
              <polyline points="15 3 21 3 21 9" />
              <line
                x1="10"
                x2="21"
                y1="14"
                y2="3"
              />
            </svg>
          </a>
        )}
      </div>
    )}
  </div>
);
